import React from "react";

const NoRecordFound = ({ message = "No record found." }) => {
  return <span>{message}</span>;
};

export default NoRecordFound;
